import { MiniChipsPropertiesType } from "@website/ui/mini-chips/mini-chips.types";

export const useMiniChips = (properties: MiniChipsPropertiesType) => {
  const { onClick } = properties;

  return {
    rootProps: {
      ...(onClick && { role: "button", onClick, tabIndex: 0 })
    },
    endIconProps: {}
  };
};
